import { useQueryClient } from '@tanstack/react-query';
import { propertyServices } from '../services/property.service';

export const usePrefetchProperties = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['properties', { ...filters, page: String(nextPage) }],
        queryFn: () => propertyServices.getProperties({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['properties', { ...filters, page: String(prevPage) }],
        queryFn: () => propertyServices.getProperties({ ...filters, page: String(prevPage) }),
      });
    }
  };

  const prefetchProperty = (propertyId) => {
    queryClient.prefetchQuery({
      queryKey: ['property', propertyId],
      queryFn: () => propertyServices.getPropertyById(propertyId),
    });
  };

  return { prefetchNextPage, prefetchPrevPage, prefetchProperty };
};
